export const MIN_ACTIVITY_DESCRIPTION_LENGTH = 60;
export const MAX_ACTIVITY_DESCRIPTION_LENGTH = 1000;

export const ES_BUSINESS_ACTIVITY_OPTIONS = [
  'agriculture_forestry_fishing',
  'manufacturing',
  'construction_real_estate_development',
  'retail_trade',
  'wholesale_import_export',
  'transport_logistics_courier',
  'professional_services',
  'legal_notarial_fiduciary',
  'it_software_technology',
  'hospitality_food_services',
  'food_supplements_production',
  'real_estate_services',
  'healthcare_social_services',
  'accounting_bookkeeping_tax',
  'consumer_lending_credit',
  'money_services',
  'cryptoasset_services',
  'investment_insurance_services',
  'gambling_betting',
  'precious_metals_art',
  'non_profit_associations',
  'other',
] as const;

export type EsBusinessActivity = (typeof ES_BUSINESS_ACTIVITY_OPTIONS)[number];

export const BUSINESS_RELATIONSHIPS_OPTIONS = [
  'suppliers_buyers_relationships',
  'distributors_producers_relationships',
  'strategic_partnership',
  'joint_venture',
  'consultants_clients_relationships',
  'franchisor_franchisee_relationships',
  'technology_providers_users_relationships',
  'outsourcing_agreements',
  'resale_agreements',
  'trade_industrial_associations',
  'public_funds',
  'public_procurement',
  'other',
] as const;
export type BusinessRelationship = (typeof BUSINESS_RELATIONSHIPS_OPTIONS)[number];

export const ASSOCIATION_SOURCE_OF_FUNDS_OPTIONS = [
  'donations_and_fundraising_events',
  'membership_fees_and_dues',
  'grants_and_public_contributions',
  'economic_activities',
  'individual_contributions_from_board_members',
  'other',
] as const;

export const ASSOCIATION_SOURCE_OF_FUNDS_OPTIONS_V2 = [
  { value: 'donations', i18nKey: 'donations' },
  { value: 'subscriptions', i18nKey: 'subscriptions' },
  { value: 'grants', i18nKey: 'grants' },
  { value: 'economic_activity', i18nKey: 'economic-activity' },
  {
    value: 'individual_contributions_from_board_members',
    i18nKey: 'individual-contributions-from-board-members',
  },
  { value: 'other', i18nKey: 'other' },
] as const;

export const BENEFICIARIES_TYPE_OPTIONS = [
  { value: 'humanitarian', i18nKey: 'humanitarian' },
  { value: 'health_protection', i18nKey: 'health-protection' },
  { value: 'civil_and_human_rights', i18nKey: 'civil-human-rights' },
  { value: 'protection_of_children_and_adolescents', i18nKey: 'child-protection' },
  { value: 'environmental_protection', i18nKey: 'environmental-protection' },
  { value: 'promotion_of_culture_sports_and_education', i18nKey: 'culture-sports-education' },
  { value: 'assistance_to_victims_of_disasters_or_emergencies', i18nKey: 'disaster-assistance' },
  { value: 'international_cooperation_and_development', i18nKey: 'international-cooperation' },
  { value: 'other', i18nKey: 'other' },
] as const;
